/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'

interface UiPageProps {
    componentName: string
    header?: React.ReactNode | React.ReactNode[]
    children: React.ReactNode | React.ReactNode[]
}

const UiPage = (props: UiPageProps) => {
    return (
        <div
            className={clsx(
                props.componentName,
                'UiPage p-3 md:p-4 xl:p-6 flex flex-col h-full min-h-0 overflow-hidden grow gap-y-3 md:gap-y-4 xl:gap-y-6'
            )}
        >
            {props.header && (
                <div className={clsx('UiPageHeader ')}>
                    <div
                        className={clsx(
                            'flex flex-col md:flex-row gap-4 items-start md:items-center justify-between'
                        )}
                    >
                        {props.header}
                    </div>
                </div>
            )}
            {props.children}
        </div>
    )
}

export default UiPage
